exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button__button___3bVSq {\n  transition: 300ms; }\n  .button__button___3bVSq:not(:disabled):hover {\n    filter: brightness(1.4); }\n", ""]);

// exports
exports.locals = {
	"button": "button__button___3bVSq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Button/button.scss
// module id = 3995
// module chunks = 6